import React from "react";
import "./styles.css";

const SkeletonIndicators: React.FC = () => {
  return (
    <div className="skeleton-page">
      {/* ======== SEÇÃO SUPERIOR (Overview) ======== */}
      <div className="skeleton-card">
        <div className="skeleton-title"></div>

        <div className="skeleton-overview-grid">
          {Array.from({ length: 20 }).map((_, i) => (
            <div key={i} className="skeleton-overview-item">
              <div className="skeleton-line label" />
              <div className="skeleton-line value" />
            </div>
          ))}
        </div>
      </div>

      {/* ======== SEÇÃO INFERIOR (Indicadores) ======== */}
      <div className="skeleton-card">
        <div className="skeleton-title"></div>

        <div className="skeleton-accordion-list">
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} className="skeleton-accordion-item"></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonIndicators;
